// Modal.js
import React, { useState, useEffect } from 'react';
import './Modal.css'

const Modal = ({ name, birthDate, setName, setBirthDate, setShowModal }) => {
  const [error, setError] = useState('');
  const [dateValue, setDateValue] = useState(() => {
    try {
      return birthDate && !isNaN(birthDate.getTime()) 
        ? birthDate.toISOString().split("T")[0] 
        : '';
    } catch {
      return '';
    }
  });

  // Sync dateValue with birthDate prop changes
  useEffect(() => {
    try {
      if (birthDate && !isNaN(birthDate.getTime())) {
        setDateValue(birthDate.toISOString().split("T")[0]);
      }
    } catch {
      // Ignore errors
    }
  }, [birthDate]);

  // Calculate min and max dates
  const today = new Date();
  const maxDate = today.toISOString().split("T")[0]; // Today (cannot be future)
  const minDate = new Date(today.getFullYear() - 120, today.getMonth(), today.getDate())
    .toISOString().split("T")[0]; // 120 years ago (reasonable limit)

  const validateDate = (dateString) => {
    if (!dateString) {
      setError('Please select a birth date');
      return false;
    }

    const selectedDate = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to compare dates only

    // Check if date is valid
    if (isNaN(selectedDate.getTime())) {
      setError('Invalid date format');
      return false;
    }

    // Check if date is in the future
    if (selectedDate > today) {
      setError('Birth date cannot be in the future');
      return false;
    }

    // Check if date is too old (more than 120 years)
    const ageInYears = (today - selectedDate) / (1000 * 60 * 60 * 24 * 365.25);
    if (ageInYears > 120) {
      setError('Please enter a valid birth date (not more than 120 years ago)');
      return false;
    }

    // Check if age is less than 0 (shouldn't happen but safety check)
    if (ageInYears < 0) {
      setError('Invalid date');
      return false;
    }

    setError('');
    return true;
  };

  const handleDateChange = (e) => {
    const newDateValue = e.target.value;
    setDateValue(newDateValue);

    if (validateDate(newDateValue)) {
      try {
        const newDate = new Date(newDateValue);
        if (!isNaN(newDate.getTime())) {
          setBirthDate(newDate);
        }
      } catch (err) {
        setError('Error processing date. Please try again.');
      }
    }
  };

  const handleNameChange = (e) => {
    const newName = e.target.value.trim();
    if (newName.length <= 50) { // Reasonable name length limit
      setName(e);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">Enter Your Details</h2>
        <input
          type="text"
          value={name}
          onChange={handleNameChange}
          placeholder="Enter your name"
          className="modal-input"
          maxLength={50}
        />
        <div>
          <input
            type="date"
            value={dateValue}
            onChange={handleDateChange}
            className={`modal-input ${error ? 'modal-input-error' : ''}`}
            min={minDate}
            max={maxDate}
            required
          />
          {error && <p className="modal-error">{error}</p>}
        </div>
        <button onClick={() => setShowModal(false)} className="modal-button">Close</button>
      </div>
    </div>
  );
};

export default Modal;